module.exports = __webpack_public_path__ + "img/6.440b0b00.jpg";